import React, { useEffect } from 'react';

import { CertificateTermsWrapper } from '@components';
import { scrollTop } from '@share/utils';

import styles from './styles.module.scss';

export function CertificateTermsAndConditionsPage(): React.ReactElement {
  useEffect(() => {
    scrollTop();
  }, []);

  return (
    <div className={styles.root}>
      <CertificateTermsWrapper />
    </div>
  );
}
